export default "__VITE_ASSET__fb5e160a__"